import React, { useEffect } from "react";
import { Box, Text, Image, Button, Heading } from "@chakra-ui/react";
import Aos from "aos";
import "aos/dist/aos.css";
const About = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <Box p="100px 0px" id="About">
      <Box
        w="85%"
        m="auto"
        display={["inline", "inline", "flex"]}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          data-aos="fade-right"
          w={["80%", "80%", "36%"]}
          m={["auto", "auto", "0px"]}
        >
          <Image
            rounded="10%"
            src="https://media2.giphy.com/media/WTjXuYA2y4o3UZly3W/giphy.gif?cid=ecf05e47m9kj795e3job6me3bw9bkd37f077w7kxg81tr8z5&rid=giphy.gif&ct=g"
            alt="gif"
          />
        </Box>
        <Box
          w={["80%", "80%", "50%"]}
          mb="25px"
          textAlign="left"
          m={["auto", "auto", "0"]}
        >
          <Heading
            fontFamily="Serif"
            textAlign={["center", "center", "left"]}
            fontSize={["35px", "35px", "55px"]}
            data-aos="flip-left"
          >
            About Me
          </Heading>
          <Text
            fontFamily="Serif"
            data-aos="fade-right"
            mb="40px"
            mt="10"
            fontSize={["15px", "15px", "15px", "25px"]}
            textAlign="justify"
          >
            {" "}
            Designing and maintaining websites and systems to serve a company's
            needs. develop these platforms to function independently.Knowledge
            of multiple front-end languages and libraries AND writing code which
            is optimized.Also be a compitent developer in exciting text company
          </Text>

          <Text
            data-aos="fade-right"
            mb="40px"
            mt="10"
            fontFamily="Serif"
            fontSize={["15px", "15px", "15px", "25px"]}
            textAlign="justify"
          >
            i Learnt Full Stack Web Development from Masai School(India's first
            Skill building School "Driven by Outcomes, Fuelled by Ambitions.")
          </Text>
          <Text
            data-aos="fade-right"
            mb="40px"
            mt="10"
            fontFamily="Serif"
            fontSize={["15px", "15px", "15px", "25px"]}
            textAlign="justify"
          >
            1200+ Hours Practical Coding , ⌛100+ Hours Soft Skill Development ,
            80+ Mini Projects , 300 Hours Data Structures & Algorithms , 100+
            Hours Math & Logic , 10+ Projects & Hackathon
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default About;
